import { render, staticRenderFns } from "./unbilled-invoices.vue?vue&type=template&id=2f84f5a8&lang=pug"
import script from "./unbilled-invoices.vue?vue&type=script&lang=js"
export * from "./unbilled-invoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports